import { useEffect, useState } from "react";
import { alpha, useTheme } from "@mui/material";
import {
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  List,
  ListItemButton,
  TextField,
  Typography,
  Box,
  Paper,
  IconButton,
} from "../../../../../components";
const DocumentoProdutoAplicacaoDialog = ({
  open,
  setOpen,
  aplicacoesProduto = [],
}) => {
  const [aplicacaoSelecionada, setAplicacaoSelecionada] = useState(null);
  const theme = useTheme();
  const corDestaque = theme.palette.primary.main;
  const corDestaqueFundo = alpha(corDestaque, 0.12);

  useEffect(() => {
    if (aplicacoesProduto?.length === 1 && open) {
      setAplicacaoSelecionada(aplicacoesProduto[0]);
    }
  }, [open, aplicacoesProduto]);

  const handleAplicacaoClick = (aplicacao) => {
    setAplicacaoSelecionada(aplicacao);
  };

  const handleClose = () => {
    setOpen(false);
    setAplicacaoSelecionada(null);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
      <div className="px-3">
        <CardHeader
          title="Visualizar Aplicações do Produto"
          action={
            <IconButton
              color="inherit"
              onClick={handleClose}
              sx={{
                backgroundColor: "#EDEEF0",
                "&:hover": { backgroundColor: "#B6BABC" },
              }}
            >
              <i
                className="ph-bold ph-x"
                style={{ fontSize: "clamp(17px, 4vw, 20px)" }}
              ></i>
            </IconButton>
          }
        />
      </div>

      <DialogContent sx={{ pb: 0 }}>
        <Grid container sx={{ minHeight: "60vh" }}>
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              borderRight: "1px solid",
              borderColor: "divider",
              py: 3,
              px: 0,
            }}
          >
            {aplicacoesProduto.length > 0 ? (
              <Box sx={{ px: 2 }}>
                <Typography variant="subtitle2" gutterBottom sx={{ m: 1 }}>
                  Lista de Aplicações
                </Typography>
                <List sx={{ maxHeight: 450, overflowY: "auto", pr: 1 }}>
                  {aplicacoesProduto.map((aplicacao) => (
                    <ListItemButton
                      key={aplicacao.id}
                      sx={{
                        borderRadius: "8px",
                        mb: 1.5,
                        py: 2,
                        px: 2.5,
                        border:
                          aplicacaoSelecionada?.id === aplicacao.id
                            ? `2px solid ${corDestaque}`
                            : "1px solid transparent",
                        backgroundColor:
                          aplicacaoSelecionada?.id === aplicacao.id
                            ? corDestaqueFundo
                            : "white",
                        boxShadow:
                          aplicacaoSelecionada?.id === aplicacao.id
                            ? `0 4px 12px ${alpha(corDestaque, 0.15)}`
                            : "0 2px 4px rgba(0, 0, 0, 0.05)",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        "&:hover": {
                          backgroundColor:
                            aplicacaoSelecionada?.id === aplicacao.id
                              ? corDestaqueFundo
                              : "#f5f5f5",
                          transform: "translateY(-1px)",
                          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
                        },
                      }}
                      disableRipple
                      selected={aplicacaoSelecionada?.id === aplicacao.id}
                      onClick={() => handleAplicacaoClick(aplicacao)}
                    >
                      <Box sx={{ width: "100%" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              variant="subtitle3"
                              sx={{
                                fontWeight: 600,
                                color:
                                  aplicacaoSelecionada?.id === aplicacao.id
                                    ? corDestaque
                                    : "text.primary",
                                mb: 0.5,
                                wordBreak: "break-word",
                              }}
                            >
                              {aplicacao.nome.toUpperCase()}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </ListItemButton>
                  ))}
                </List>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  p: 3,
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "center", fontWeight: 500 }}
                >
                  Nenhuma aplicação cadastrada.
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            md={9}
            sx={{
              py: 3,
              px: 3,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
            }}
          >
            {aplicacaoSelecionada ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: "text.secondary",
                    mt: 1,
                    mb: 2,
                  }}
                >
                  {`Descrição da Aplicação - ${aplicacaoSelecionada.nome}`}
                </Typography>
                <Paper
                  elevation={0}
                  sx={{
                    flex: 1,
                    border: "1px solid #EDEEF0",
                    boxShadow: "none",
                    borderRadius: "8px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "380px",
                    maxHeight: "380px",
                  }}
                >
                  <TextField
                    id="descricao"
                    name="descricao"
                    label=""
                    margin="none"
                    fullWidth
                    multiline
                    value={
                      aplicacaoSelecionada.descricao ||
                      "Nenhuma descrição disponível."
                    }
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                      sx: {
                        border: "none",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        fontSize: "0.95rem",
                        lineHeight: 1.7,
                        padding: "10px 20px 35px 10px",
                        minHeight: "400px",
                        maxHeight: "400px",
                        overflowY: "auto",
                        alignItems: "flex-start",
                      },
                    }}
                  />
                </Paper>
              </Box>
            ) : (
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 4,
                }}
              >
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  <i
                    className="ph ph-arrow-left"
                    style={{ fontSize: 36, color: "#bdbdbd" }}
                  />
                </Box>
                <Typography
                  variant="h6"
                  color="text.secondary"
                  sx={{ mb: 1, fontWeight: 500, textAlign: "center" }}
                >
                  Selecione uma aplicação
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "center", maxWidth: 280 }}
                >
                  Clique em uma aplicação na lista ao lado para visualizar sua
                  descrição detalhada.
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentoProdutoAplicacaoDialog;
